@if (show()) {


<kendo-dialog (close)="close()" [width]="450" [height]="500">
    <kendo-dialog-titlebar>
        <div class="custom-title">
            <span class="title-text">Account Contacts</span>
        </div>
    </kendo-dialog-titlebar>

    <div class="container">
        @if (isBusy()) {
            <div class="account-contact-loader-overlay">
                <kendo-loader type="converging-spinner" size="large" themeColor="secondary"></kendo-loader>
            </div>
        }
        <!-- Primary Account Contact -->
        <div class="primary-contact-section">
            <div class="primary-section-header">
                <span class="section-header-text">Your Organization's Primary Account Contact</span>
                @if (canManageContacts()) {
                    <button
                        kendoButton
                        look="flat"
                        class="edit-toggle-btn"
                        [class.edit-icon-active]="editPrimaryContact()"
                        (click)="editPrimary()"
                        [attr.title]="editPrimaryContact() ? 'Stop editing primary contact' : 'Edit primary account contact'"
                        aria-label="Edit primary account contact">
                        <app-edit-icon [size]="25"></app-edit-icon>
                </button>
                }
            </div>
            <hr />
            @if (canManageContacts() && editPrimaryContact()) {

            <form class="form-container" [formGroup]="primaryContactFormGroup">

                <!-- Dropdown -->
                <div class="row full-width">
                    <kendo-dropdownlist
                        #primaryContactDropdown
                        formControlName="contactId"
                        [disabled]="isBusy()"
                        [data]="contacts"
                        textField="name"
                        valueField="id"
                        [valuePrimitive]="true"
                        (valueChange)="onPrimaryContactSelectionChange($event)">
                        <ng-template kendoDropDownListValueTemplate let-dataItem>
                            {{ getSelectedContactLabel(primaryContactFormGroup, dataItem) }}
                        </ng-template>
                        <ng-template kendoDropDownListFooterTemplate>
                            <div class="footer-action" (click)="createContact('primary')">
                                + Create New Contact
                            </div>
                        </ng-template>
                    </kendo-dropdownlist>

                </div>

                <!-- Firstname + Lastname -->
                <div class="row two-column">
                    <input kendoTextBox placeholder="Firstname" formControlName="firstName" />
                    <input kendoTextBox placeholder="Lastname" formControlName="lastName" />
                </div>
                @if (isNameInvalid(primaryContactFormGroup)) {
                <div class="validation-message">
                    You must enter a valid first and last name for this contact
                </div>
                }

                <!-- Email -->
                <div class="row label-input">
                  
                    <input kendoTextBox placeholder="email" formControlName="emailAddress" />
                </div>
                @if (isControlInvalid(primaryContactFormGroup, 'emailAddress')) {
                <div class="validation-message">
                    You must enter a valid email for this contact
                </div>
                }

                <!-- Phone -->
                 
     <div class="row two-column phone-row">
            <kendo-maskedtextbox
                placeholder="phone"
                formControlName="phoneNumber"
                [mask]="phoneMask">
            </kendo-maskedtextbox>
            <input kendoTextBox placeholder="ext" formControlName="extension" />
        </div>

            @if (isControlInvalid(primaryContactFormGroup, "phoneNumber")) {
              <div class="validation-message">
                You must enter a valid phone number for this contact
              </div>
            }
          </form>

          <hr />
        } @else {
          @if (primaryContact) {
            <div class="contact-details">
              <div class="name">
                {{ (primaryContact?.firstName || '') + (primaryContact?.firstName && primaryContact?.lastName ? ' ' : '') + (primaryContact?.lastName || '') }}
              </div>
              @if (primaryContact.emailAddress) {
                <div class="email">
                  {{ primaryContact.emailAddress }}
                </div>
              }
              @if (primaryContact?.phoneNumber) {
                <div class="phone">{{ maskPhoneNumber(primaryContact?.phoneNumber) }}</div>
                <div class="phone">
                  Ext.{{ primaryContact.phoneNumberExtension }}
                </div>
              }
            </div>
          } @else {
            <div class="contact-details">
              <div class="name">
                No Primary Contact is present for the selected organization.
              </div>
            </div>
          }
          <hr />
        }
      </div>
      <!-- Support Contact -->
      <div class="support-contact-section">
        <div class="section-header">
          <span class="section-header-text"
            >Your Organization's Support Contact</span
          >
          @if (canManageContacts()) {
            <button
              kendoButton
              look="flat"
              class="edit-toggle-btn"
              [class.edit-icon-active]="editSupportContact()"
              (click)="editSupport()"
              [attr.title]="
                editSupportContact()
                  ? 'Stop editing support contact'
                  : 'Edit support contact'
              "
              aria-label="Edit support contact"
            >
              <app-edit-icon [size]="25"></app-edit-icon>
            </button>
          }
        </div>
        <hr />
        @if (!canManageContacts() || !editSupportContact()) {
          @if (supportContact) {
            <div class="contact-details">
              <div class="name">
                {{ (supportContact?.firstName || '') + (supportContact?.firstName && supportContact?.lastName ? ' ' : '') + (supportContact?.lastName || '') }}
              </div>
              @if (supportContact.emailAddress) {
                <div class="email">
                  {{ supportContact.emailAddress }}
                </div>
              }
              @if (supportContact?.phoneNumber) {
                <div class="phone">{{ maskPhoneNumber(supportContact?.phoneNumber) }}</div>
                <div class="phone">
                  Ext.{{ supportContact.phoneNumberExtension }}
                </div>
              }
            </div>
          } @else {
            <div class="contact-details">
              <div class="name">
                No Support Contact is present for the selected organization
              </div>
            </div>
          }
        } @else {
          <form class="form-container" [formGroup]="supportContactFormGroup">
            <!-- Dropdown -->
            <div class="row full-width">
              <kendo-dropdownlist
                #supportContactDropdown
                formControlName="contactId"
                [disabled]="isBusy()"
                [data]="contacts"
                textField="name"
                valueField="id"
                [valuePrimitive]="true"
                (valueChange)="onSupportContactSelectionChange($event)"
              >
                <ng-template kendoDropDownListValueTemplate let-dataItem>
                  {{
                    getSelectedContactLabel(supportContactFormGroup, dataItem)
                  }}
                </ng-template>
                <ng-template kendoDropDownListFooterTemplate>
                  <div class="footer-action" (click)="createContact('support')">
                    + Create New Contact
                  </div>
                </ng-template>
              </kendo-dropdownlist>
            </div>

            <!-- Firstname + Lastname -->
            <div class="row two-column">
              <input
                kendoTextBox
                placeholder="Firstname"
                formControlName="firstName"
              />
              <input
                kendoTextBox
                placeholder="Lastname"
                formControlName="lastName"
              />
            </div>
            @if (isNameInvalid(supportContactFormGroup)) {
              <div class="validation-message">
                You must enter a valid first and last name for this contact
              </div>
            }

            <!-- Email -->
            <div class="row label-input">
              <input
                kendoTextBox
                placeholder="email"
                formControlName="emailAddress"
              />
            </div>
            @if (isControlInvalid(supportContactFormGroup, "emailAddress")) {
              <div class="validation-message">
                You must enter a valid email for this contact
              </div>
            }

                <!-- Phone -->
                                <div class="row two-column phone-row">
            <kendo-maskedtextbox
                placeholder="phone"
                formControlName="phoneNumber"
                [mask]="phoneMask">
            </kendo-maskedtextbox>
            <input kendoTextBox placeholder="ext" formControlName="extension" />
        </div>
                @if (isControlInvalid(supportContactFormGroup, 'phoneNumber')) {
                <div class="validation-message">
                    You must enter a valid phone number for this contact
                </div>
                }

              

            </form>
            }
        </div>
        <hr />
    </div>

    <!-- Actions (Footer) -->
    <kendo-dialog-actions layout="center">
      @if (canManageContacts()) {
        <button
          kendoButton
          class="btn save-btn"
          (click)="save()"
          [disabled]="isBusy()"
        >
          @if (!isSavingContacts) {
            Save
          } @else {
            <kendo-loader
              type="pulsing"
              size="small"
              themeColor="light"
            ></kendo-loader>
          }
        </button>
      }

      <button
        kendoButton
        class="btn close-btn"
        (click)="close()"
        [disabled]="isBusy()"
      >
        Close
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
  @if (isDialogOpen) {
    <kendo-dialog (close)="closeDialog()" [width]="521">
      <kendo-dialog-titlebar>
        <div class="custom-title">
          <span class="contact-exist-title">Contact already exists</span>
        </div>
      </kendo-dialog-titlebar>

      <!-- Message -->
      <div class="dialog-content">
        <p>{{ dialogMessage }}</p>

        @if (showCandidateSelection) {
          <div class="candidate-list">
            @for (candidate of dialogCandidates; track candidate.contactId) {
              <label class="candidate-item">
                <input
                  type="radio"
                  name="dialogContact"
                  [value]="candidate.contactId ?? ''"
                  [checked]="
                    selectedDialogContactId === (candidate.contactId ?? '')
                  "
                  (change)="selectDialogContact(candidate.contactId ?? '')"
                />
                <span>{{ getDialogContactDisplay(candidate) }}</span>
              </label>
            }
          </div>
        }
      </div>

      <!-- Actions -->
      <kendo-dialog-actions class="dialog-actions">
        @if (!showCandidateSelection) {
          <button kendoButton (click)="useExisting()" class="btn save-btn">
            Yes, use existing contact
          </button>

          <button kendoButton (click)="createNew()" class="btn close-btn">
            No, create new contact
          </button>
        } @else {
          <button
            kendoButton
            (click)="applySelectedExisting()"
            [disabled]="!selectedDialogContactId"
            themeColor="primary"
          >
            Use selected contact
          </button>

          <button kendoButton (click)="closeDialog()" themeColor="primary">
            Cancel
          </button>
        }
      </kendo-dialog-actions>
    </kendo-dialog>
  }
}
